import React from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import IntroSection from '../components/IntroSection';
import GallerySection from '../components/GallerySection';
import RoomsSection from '../components/RoomsSection';
import FeaturesSection from '../components/FeaturesSection';
import LocationSection from '../components/LocationSection';
import FloorPlanSection from '../components/FloorPlanSection';
import ClosingSection from '../components/ClosingSection';
import PriceSection from '../components/PriceSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#F7F7F5]" data-testid="landing-page">
      <Navigation />
      <main>
        <HeroSection />
        <IntroSection />
        <GallerySection />
        <RoomsSection />
        <FeaturesSection />
        <LocationSection />
        <FloorPlanSection />
        <ClosingSection />
        <PriceSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
